<template>
  <b-modal
    @change="change"
    :visible="value"
    :modal-class="`theme-${$setup.theme}-modals`"
    size="md"
    scrollable
    hide-footer
    hide-header
    centered
  >
    <div class="support-modal-component">
      <h5 class="text-center mb-4">Suporte</h5>
      <button class="btn icon-close" @click="$emit('input', false)" />
      <template v-if="$setup.setup.metadata_support">
        <p>{{ description }}</p>
        <p><strong>Telefone:</strong> {{ phone }}</p>
        <p><strong>E-mail:</strong> {{ email }}</p>
        <p class="d-flex align-items-center">
          <strong class="mr-1">Whatsapp:</strong>
          {{ phone }}
          <a
            :href="wppLink"
            class="ml-2 text-decoration-none align-items-center"
            target="_blank"
            ><i class="icon-external-link text-primary"></i
          ></a>
        </p>
        <p><strong>Horário de atendimento:</strong> {{ opening_hours }}</p>
      </template>
      <p v-else class="text-center">
        As informações de suporte ainda não foram cadastradas pelo produtor.
      </p>
      <div class="d-flex justify-content-center mb-lg-2 mb-4 pt-4">
        <button class="btn btn-close px-4" @click="$emit('input', false)">
          Fechar
        </button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { phoneMask, prepareWppNumber, removeMask } from "@/functions/helpers";
import get from "lodash/get";

export default {
  props: {
    value: Boolean
  },
  computed: {
    description() {
      return get(this.$setup, "setup.metadata_support.description", "-");
    },
    email() {
      return get(this.$setup, "setup.metadata_support.email", "-");
    },
    phone() {
      return phoneMask(
        removeMask(get(this.$setup, "setup.metadata_support.phone", ""))
      );
    },
    opening_hours() {
      return get(this.$setup, "setup.metadata_support.opening_hours", "-");
    },
    wppLink() {
      const { setup } = this.$setup;
      if (
        setup.metadata_support?.link_chat_whatsapp &&
        setup.metadata_support?.link_chat_whatsapp.length > 0
      ) {
        return setup.metadata_support.link_chat_whatsapp;
      }

      if (setup.metadata_support.phone)
        return `https://api.whatsapp.com/send?phone=+${prepareWppNumber(
          removeMask(setup.metadata_support.phone)
        )}&text=Olá suporte, gostaria de ajuda.`;

      return false;
    }
  },
  methods: {
    change(val) {
      this.$emit("input", val);
    }
  }
};
</script>
<style lang="scss" scoped>
.support-modal-component {
  .icon-close {
    position: absolute;
    top: 2%;
    right: 0%;
  }

  h5 {
    font-size: 18px;
    font-weight: 500;
  }

  p {
    color: var(--verso-dark-branco, #fff);
    font-feature-settings: "clig" off, "liga" off;
    font-family: "Noto Sans", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;

    span {
      font-weight: 500;
    }

    i {
      font-size: 24px;
    }

    @media screen and (max-width: 768px) {
      font-size: 12px;

      i {
        font-size: 18px;
      }
    }
  }
}
</style>
